<template>
  <pack>

    <!-- 未开通 -->
    <template v-if="!isOpen">
      <img :src="up_level" class="banner">
      <p class="gray fz14 mt8">想要打造一个完全属于自己的品牌？</p>
      <p class="gray fz14 mt8">想要灵活定制的CMS系统？</p>
      <p class="mt8 fwb">升级即可使用</p>
      <app-link to="/cms-website/upgrade"><zt-button class="mt16" type="primary">立即升级</zt-button></app-link>
    </template>

    <!-- 过期 -->
    <template v-else>
      <img :src="cms_end" class="banner">
      <p class="fz16">您的{{ vipCN }}已过期</p>
      <p class="fz14 gray mt8">为了CMS系统正常访问，请及时续费</p>
      <app-link to="/cms-website/upgrade"><zt-button class="mt16" type="primary">马上续费</zt-button></app-link>
    </template>

  </pack>
</template>

<script>
import up_level from '@imgs/up_level.png'
import cms_end from '@imgs/cms_end.png'
import { mapGetters } from 'vuex'
export default {
  name: 'CMSUserUnactivate',
  data: () => ({
    up_level,
    cms_end,
  }),
  computed: {
    ...mapGetters([ 'user_vip', 'vipCN' ]),  // 开通过（已过期）

    isOpen() {
      return this.user_vip != 0
    },
  },
}
</script>

<style lang="scss" scoped>
.pack {
  text-align: center;
  padding: 32px !important;
}
.banner {
  width: 240px;
  display: block;
  margin: 0 auto 17px;
}
.zt-button {
  width: 140px;
}

.gray {
  color: $theme-textsecond;
}
.fz14 {
  font-size: 14px;
  line-height: 20px;
}
.fz16 {
  font-size: 16px;
  line-height: 22px;
}
.fwb {
  font-weight: bold;
}
</style>